<template>
  <div class="home">
    <div class="home-content">
      <CharacterComponent />
      <ShopComponent />
    </div>
    <HeaderComponent />
    <RuleComponent />
    <HistoryComponent />
    <SpendComponent />
    <ToastComponent />
    <DiscountComponent />
    <LoadingComponent />
    <AlertDialog v-if="$bus.alertShow" />
    <EuPolicyAlert :show.sync="euPolicyShow" :content="euPolicyContent" :storageText="euPolicyChoiceContent.storageText" :adText="euPolicyChoiceContent.adText"></EuPolicyAlert>

  </div>
</template>

<script>
import { getSessionStorage, initGA } from '@/utils/assist'
import HeaderComponent from '@/components/header'
import RuleComponent from '@/components/dialog/rule'
import HistoryComponent from '@/components/dialog/history'
import SpendComponent from '@/components/dialog/spend'
import CharacterComponent from '@/components/character'
import ShopComponent from '@/components/shop'
import ToastComponent from '@/components/base/toast'
import DiscountComponent from '@/components/dialog/discount'
import LoadingComponent from '@/components/base/loading'
import AlertDialog from '@/components/base/alert'
import EuPolicyAlert from '@/components/base/EuPolicyAlert.vue'
import { euData, euPopupInject } from '@/utils/eu_popup'

export default {
  name: 'home',
  components: {
    HeaderComponent,
    RuleComponent,
    HistoryComponent,
    CharacterComponent,
    ShopComponent,
    SpendComponent,
    ToastComponent,
    DiscountComponent,
    LoadingComponent,
    AlertDialog,
    EuPolicyAlert
  },
  data () {
    return {
      ...euData
    }
  },
  methods: {
    drawDiscount () {
      this.$api
        .discount({
          shop: -1
        })
        .then(res => {
          // 抽取折扣期间
          this.$bus.discount = res.data.discount
        })
    },
    initInfo () {
      let accessToken = getSessionStorage(`${PROJECT_NAME}AccessToken`) || ''
      let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
      if (!accessToken) {
        const errorMsg = {
          type: 'error',
          code: 'TOAST_LOGIN_FAILED', // DUPLICATE|TIMEOUT|other key
          closeable: false
        }
        return this.$bus.handleError(errorMsg)
      }

      this.$api
        .info({
          access_token: accessToken,
          lang: lang
        })
        .then(response => {
          // NOTE error state has been already handled in request.js
          // TODO 成功后处理并缓存数据
          let data = response.data
          this.$bus.uid = data.uid
          this.$bus.gems = data.gems
          this.$bus.transify = data.transify
          console.log(this.googleAnalyticsPopupInject, '???')
          this.googleAnalyticsPopupInject(data)
          if (data['policy_popup']) {
            const {
              popup_title: policyTitle,
              popup_content: policyCtx,
              checked: policyHide
            } = data['policy_popup']
            this.$bus.alertTitle = policyTitle
            this.$bus.alertContent = policyCtx
            this.$bus.alertShow = !policyHide
          }
          // rule
          this.$bus.ruleDialogContent = data.event.rules

          // cost
          const cost = data.stats.cost
          this.$bus.cost = cost
          this.$bus.currentCost = cost[0]
          this.$bus.costLimit = data.event.cost_limit
          this.$bus.bigDiscount = data.stats.big_discount
          this.$bus.useBig = data.stats.use_big

          // shop
          const shop = data.shop
          const purchase = data.stats.purchase
          this.$bus.shop = shop
          this.$bus.shopFood = this.$bus.sortListByPk(shop[0], purchase[0], 0)
          this.$bus.shopFishing = this.$bus.sortListByPk(
            shop[1],
            purchase[1],
            1
          )
          this.$bus.shopShoot = this.$bus.sortListByPk(shop[2], purchase[2], 2)
          // discount
          this.$bus.discount = data.stats.discount

          this.$bus.currentDiscount = this.$bus.discount[0]
          this.$bus.dialogCharacterTextStatus = `welcomefood`

          // 已经购买过，但是还未超出limit
          if (
            this.$bus.currentCost > 0 &&
            this.$bus.currentCost < this.$bus.costLimit[0]
          ) {
            this.$bus.dialogCharacterTextStatus = 'purchase'
          }
          // 满足条件，但是没抽取
          if (
            this.$bus.currentCost >= this.$bus.costLimit[0] &&
            this.$bus.bigDiscount[0] === 0
          ) {
            this.$bus.dialogCharacterTextStatus = 'ticket'
          }

          if (
            this.$bus.bigDiscount[0] !== 0 &&
            this.$bus.bigDiscount[0] !== -1
          ) {
            this.$bus.dialogCharacterTextStatus = 'ticket'
          }

          // 判断是否购买了物品
          if (this.$bus.bigDiscount[0] === -1) {
            this.$bus.dialogCharacterTextStatus = 'purchase'
          }

          if (this.$bus.isPurchaseAll()) {
            this.$bus.dialogCharacterTextStatus = 'all'
          }

          // 判断是否是第一次
          if (this.$bus.discount.every(item => item === 0)) {
            this.$bus.currentDiscount = 0 // NOTE 首页动画
            this.$bus.isFirst = true
            this.drawDiscount()

            // update dialogCharacterTextStatus
            this.$bus.dialogCharacterTextStatus = 'base'
          }

          document.body.setAttribute('data-lang', data.lang)
          initGA(data.region, this.$bus.uid, data.data_log_name || '')
        })
        .catch(error => {
          // NOTE error has been already handled in request.js
          console.log(error, 'initInfo...')
        })
    },
    googleAnalyticsPopupInject: euPopupInject
  },
  mounted () {
    this.initInfo()
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  text-transform: uppercase;

  .home-content {
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 100%;
  }
  @media only screen and (min-device-height: 768px) {
    .home-content {
      align-items: center !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue